/** Default required customer docs by work type (must match backend ITask defaults). */
export const TASK_TYPE_OPTIONS = [
  { name: 'GST', value: 'GST' },
  { name: 'IT Returns', value: 'IT Returns' },
  { name: 'TDS', value: 'TDS' },
  { name: 'Other', value: 'Other' },
];

export const DEFAULT_REQUIRED_DOCS_BY_TASK_TYPE = {
  GST: ['Bank Statement', 'Sales Bills', 'Purchase Bills'],
  'IT Returns': ['Form 16', 'Investment Proofs', 'Bank Statement'],
  TDS: ['TDS Challans', 'Salary Register'],
  Other: [],
};

export const requiredDocsForTaskType = (taskType) => {
  if (!taskType) return [];
  return [...(DEFAULT_REQUIRED_DOCS_BY_TASK_TYPE[taskType] || [])];
};

export const submissionStatusLabel = (status) => {
  switch (status) {
    case 'submitted':
      return 'Submitted by customer';
    case 'partially_submitted':
      return 'Partially submitted';
    case 'pending_from_customer':
    default:
      return 'Pending from customer';
  }
};
